import React from 'react';
import { Button, Divider } from 'antd';
import { DatabaseIcon, DeleteIcon, MonitorUploadIcon } from '../icons';
import { DataSourceType } from '../../hooks/useInitDataMap';
import { DataSourceTableType } from '@/types/dataMap';

interface SystemItemProps {
  system: DataSourceType;
  onDeleteSystem: (system: DataSourceType) => void;
  onAddTable: (systemId: string) => void;
  onTableDragStart: (datasourceId: string, tableId: string, e: React.DragEvent) => void;
  onSystemClick: (systemId: string) => void;
  onTableClick: (tableId: string) => void;
  onDeleteTableClick: (systemId: string, tableId: string) => void;
  isSelected: boolean;
  isShowTable?: boolean
}

const SystemItem: React.FC<SystemItemProps> = ({ 
  system, 
  onDeleteSystem, 
  onAddTable, 
  onTableDragStart, 
  onSystemClick, 
  onTableClick, 
  onDeleteTableClick,
  isSelected,
  isShowTable = true,
}) => {
  
  return (
    <div key={system.id} className={`relative p-4 pb-0 ${isSelected ? 'bg-blue-50 rounded' : ''}`}>
      <div className="flex items-center mb-3 gap-2 cursor-pointer" onClick={() => onSystemClick(system.id)}>
        <div className="flex-shrink-0">
          {system.datasourceType === 'FILES' ? <MonitorUploadIcon /> : <DatabaseIcon />}
        </div>
        <div className="text-sm font-medium text-[#132347] truncate max-w-[180px]">{system.name}</div>
      </div>
      {/* 删除图标 */}
      {
        system.datasourceType !== 'LOCAL' && <div className="absolute top-4 right-4">
        <DeleteIcon onClick={() => onDeleteSystem(system)} />
      </div>
      }
      {
        isShowTable && <div className="ml-8 mb-3 h-6 flex items-center" style={{ zIndex: 20 }}>
        <div className="flex flex-1 items-center gap-2 overflow-x-auto custom-scrollbar">
          {system.tables.map((table, index) => (
            <div 
              key={index} 
              className="flex items-center gap-1 text-sm text-[#4a5568] bg-[#f5f7ff] px-1 rounded border border-[#e0e7ff] text-[12px] cursor-pointer"
              draggable
              onDragStart={(e) => onTableDragStart(system.id, table.id, e)}
              onClick={() => onTableClick(table.id)}
            >
              <span className="truncate max-w-[96px]">{table.tableName}</span>
              <svg width='12' height='12' onClick={() => onDeleteTableClick(system.id, table.id)} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2394">
                <path d="M572.27 512l303.25-351.086c5.12-5.778 0.731-14.628-7.022-14.628h-92.16a19.017 19.017 0 0 0-14.263 
                6.363L512 442.222 261.851 152.649a18.651 18.651 0 0 0-14.043-6.363h-92.16c-7.9 0-12.142 8.85-7.095 14.628L451.73
                 512 148.48 863.086c-5.12 5.778-0.731 14.628 7.022 14.628h92.16a19.017 19.017 0 0 0 14.263-6.363L512 581.778l250.149 
                 289.573a18.651 18.651 0 0 0 14.116 6.363h92.16c7.9 0 12.142-8.85 7.095-14.628L572.27 512z" p-id="2395" fill="#8a8a8a"> 
                </path>
              </svg>
            </div>
          ))}
        </div>
        <div className="flex items-center bg-white px-2" style={{ zIndex: 1 }}>
          <Button 
            type="link" 
            size="small" 
            className="text-[#1890ff] text-xs whitespace-nowrap"
            onClick={() => onAddTable(system.id)}
          >
            + {system.datasourceType === 'FILES' ? '添加文件' : '添加表'}
          </Button>
        </div>
      </div>
      }
      <Divider className="mt-4 mb-0 border-t border-[#f0f0f0]" />
    </div>
  );
};

export default SystemItem;